import script from "./DocumentTab.vue?vue&type=script&setup=true&name=NoticeOfficeTab&lang=js"
export * from "./DocumentTab.vue?vue&type=script&setup=true&name=NoticeOfficeTab&lang=js"

import "./DocumentTab.vue?vue&type=style&index=0&id=48d03306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d03306"]])

export default __exports__